<template>
  <!-- START JUMBOTRON -->
  <div class="jumbotron" data-pages="parallax">
    <div class="container-fluid sm-p-l-20 sm-p-r-20">
      <div class="inner">
        <!-- START BREADCRUMB -->
        <ul class="breadcrumb">
          <li>
            <p>Espace Agence</p>
          </li>
          <li>
            <a href="#" class="active">Client  </a>
          </li>
          <li v-if="currentRoute === 'customer' || currentRoute === 'contract-management' ">
            {{get_customer_name}}
          </li>
        </ul>
        <!-- END BREADCRUMB -->
      </div>
    </div>
  </div>
  <!-- END JUMBOTRON -->
</template>

<script>
 export default {

   computed: {
       currentRoute () {
         const name = this.$route.name
         return name
       },

       get_customer_name : function() {
        //  if (this.currentRoute == "customer" ) {
           const cname = this.$store.state.customer.profile.name
           return cname
        //  }
       }

   },
 }
</script>



// WEBPACK FOOTER //
// client/components/Jumbotron.vue